import { Amplify } from "aws-amplify";
import {
  AWS_REGION,
  COGNITO_USER_POOL_CLIENT_ID,
  COGNITO_USER_POOL_ID,
} from "../constants";

/**
 * Configures Amplify Auth against the fixed "er-internal-ops" Cognito user
 * pool — this is a single, static pool for our own ops staff, not the
 * per-tenant pool resolution admin-frontend does via `window.TENANT_INFO`.
 *
 * The pool does not exist yet. Until `REACT_APP_SYSTEM_USER_POOL_ID` /
 * `REACT_APP_SYSTEM_USER_POOL_CLIENT_ID` are filled in (see `.env.example`),
 * this configures Amplify with empty IDs — the app still builds and shows
 * the login screen, but sign-in cannot complete.
 *
 * Imported once, for its side effect, before the app renders (see index.tsx).
 */
Amplify.configure({
  Auth: {
    region: AWS_REGION,
    userPoolId: COGNITO_USER_POOL_ID,
    userPoolWebClientId: COGNITO_USER_POOL_CLIENT_ID,
  },
});
